import { useEffect, useState } from 'react'

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]
const DEFAULT_PAGE_SIZE = 25

/**
 * Per-page, per-company "rows per page" preference, persisted to localStorage so it
 * survives a refresh (stored like the list filters). `entity` is e.g. 'leads'.
 */
export function usePersistedPageSize(entity: string, companyId: string | undefined) {
  const key = `${entity}-page-size-${companyId ?? 'unknown'}`
  const [pageSize, setPageSize] = useState<number>(() => {
    if (!companyId) return DEFAULT_PAGE_SIZE
    const n = parseInt(localStorage.getItem(key) ?? '', 10)
    return PAGE_SIZE_OPTIONS.includes(n) ? n : DEFAULT_PAGE_SIZE
  })
  useEffect(() => {
    if (companyId) localStorage.setItem(key, String(pageSize))
  }, [key, pageSize, companyId])
  return [pageSize, setPageSize] as const
}
